<template>
  <v-row>
    <v-col cols="12">
      <v-sheet>
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Today
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-spacer/>
        </v-toolbar>
      </v-sheet>
      <v-sheet class="px-2">
        <v-calendar
          ref="calendar"
          v-model="focus"
          :type="type"
          :weekdays="[1, 2, 3, 4, 5, 6, 0]"
          :events="events"
          interval-height="250"
          color="primary"
          :event-color="getEventColor"
          @click:event="handleEventClick"
        />
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { SUBSCRIPTION_ACTIVITY_QUERY } from "@/constants/graphql/coach/coaching";
import WorkoutBlockMixin from "@/components/shared/mixins/WorkoutBlockMixin.js";

export default {
  name: "Calendar",
  mixins: [WorkoutBlockMixin],
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      type: "month",
      focus: "",
      events: [],
      workoutSubscriptionBlock: null,
      nutritionSubscriptionBlock: null,
    };
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    getEventColor(event) {
      return {
        PROGRAM: "red",
        COURSE: "yellow",
        NUTRITION: "green",
        WORKOUT: "blue",
        REST_DAY: "grey",
        LIVE_EVENT: "pink",
      }[event.type];
    },
    setToday() {
      this.focus = "";
    },
    handleEventClick(eventParsed) {
      let eventBlock = eventParsed.event;
      let url = null;

      switch (eventBlock.type) {
        case "WORKOUT":
          url = `${this.$appEndPoint}/unit-activity/${eventBlock.id}`;
          break;
        case "PROGRAM":
        case "COURSE":
          url = `${this.$appEndPoint}/program/${eventBlock.id}`;
          break;
        case "NUTRITION":
          url = `${this.$appEndPoint}/nutrition/${eventBlock.id}`;
          break;
      }
      if (url != null) {
        window.open(url, "_blank");
      }
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
  },
  apollo: {
    workoutSubscriptionBlocks: {
      query: SUBSCRIPTION_ACTIVITY_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
      result(response) {
        if (response.data && !response.loading) {
          let edges = response.data.workoutSubscriptionBlocks.edges;
          this.events = this.getWorkoutBlockEvents(edges);

          let nutritionEdges = response.data.nutritionSubscriptionBlocks.edges;
          nutritionEdges.forEach((element) => {
            let subscriptionBlock = element.node;
            let event = {
              id: this.getId(subscriptionBlock.nutritionBlock.id),
              start: subscriptionBlock.startDate,
              name: subscriptionBlock.nutritionBlock.title,
              type: "NUTRITION",
              nutritionBlock: subscriptionBlock,
            };
            this.events.push(event);
          });
        }
      },
    },
  },
};
</script>

<style scoped></style>
